import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';
import * as TabelaAPI from '../../../api/tabela';

import Input from '../../form/Input';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

/* utils */
import { formatarNumeroDecimal } from '../../../utils/masks';

function Form({ token, dados, setDados, empresaId, empresaIds, handleSubmit, btnText, caminhoVoltar, OptionsEmpresa }) {
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    function handleChange(e) {
        const { name, value, checked, type } = e.target;
        let valor = value;
        if (name === 'aliquota') {
            valor = formatarNumeroDecimal(e.target.value);
        }
        setDados({ ...dados, [name]: type === 'checkbox' ? checked : valor });
    }

    async function handleOnBlur(e) {
        //verifica duplicidade
        if (e.target.name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(
                document.getElementById('empresaId').value,
                'Cor',
                e.target.value
            );

            if (duplicidade?.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/Cores/CreateOrEdit`, {
                    uuid: duplicidade.uuid,
                });
            }
        }
    }
    function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>COR</h1>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="COR"
                    title="Digite o nome da COR"
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.descricao || ''}
                    required={true}
                />
                <Checkbox
                    title="Quando marcado a forma de pagamento ou recebimento esta ATIVO"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
